<div
  id="carouselExampleIndicators"
  class="carousel slide"
  data-bs-ride="carousel"
>
  <div class="carousel-indicators">
    <button
      type="button"
      class="slider-indicator active"
      data-bs-target="#carouselExampleIndicators"
      data-bs-slide-to="0"
      aria-current="true"
      aria-label="Slide 1"
    ></button>
    <button
      type="button"
      class="slider-indicator"
      data-bs-target="#carouselExampleIndicators"
      data-bs-slide-to="1"
      aria-label="Slide 2"
    ></button>
    <button
      type="button"
      class="slider-indicator"
      data-bs-target="#carouselExampleIndicators"
      data-bs-slide-to="2"
      aria-label="Slide 3"
    ></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img
        class="left-intro"
        [src]="'/assets/flyplus/auth/auth-slider-1.png' | assets"
        alt="..."
      />
      <div class="carousel-caption d-none d-md-block">
        <h4 class="my-3" [ngClass]="{ dark: isWhiteBackground }" translate>
          Door to door luggage delivery
        </h4>
        <p [ngClass]="{ dark: isWhiteBackground }" translate>
          D to D delivery breakdown
        </p>
      </div>
    </div>

    <div class="carousel-item">
      <img
        class="left-intro"
        [src]="'/assets/flyplus/auth/auth-slider-2.png' | assets"
        alt="..."
      />
      <div class="carousel-caption d-none d-md-block">
        <h4 class="my-3" [ngClass]="{ dark: isWhiteBackground }" translate>
          The Experience
        </h4>
        <p [ngClass]="{ dark: isWhiteBackground }" translate>
          Track delivery breakdown
        </p>
      </div>
    </div>

    <div class="carousel-item">
      <img
        class="left-intro"
        [src]="'/assets/flyplus/auth/auth-slider-3.png' | assets"
        alt="..."
      />
      <div class="carousel-caption d-none d-md-block">
        <h4 class="my-3" [ngClass]="{ dark: isWhiteBackground }" translate>
          Experience. Seamless. Travelling
        </h4>
        <p [ngClass]="{ dark: isWhiteBackground }" translate>
          Experience. Seamless. Travelling breakdown
        </p>
      </div>
    </div>
  </div>
</div>
